// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"78":"locale-hu-json","240":"locale-sr-json","990":"locale-en-json"}[chunkId] || chunkId) + "." + {"78":"d1d755e5","240":"de45c21b","453":"76788f8c","990":"0e7963fa"}[chunkId] + ".chunk.js";
};